/* Cadeaux automatiques Bougie Frenchie (sections/bf-auto-gifts.liquid) :
   ajoute les produits offerts dès qu'un produit payant est dans le panier, les retire sinon,
   et remplace leur prix par « Offert » dans le tiroir panier et sur la page panier. */
(function () {
  var el = document.getElementById('BfAutoGifts');
  if (!el) return;
  var cfg;
  try { cfg = JSON.parse(el.textContent); } catch (e) { return; }
  var gifts = cfg.gifts || [];
  if (!gifts.length) return;
  var giftIds = gifts.map(function (g) { return g.id; });
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var internal = 0;
  var timer = null;
  var running = false;
  var again = false;

  function isGift(item) { return giftIds.indexOf(item.variant_id || item.id) !== -1; }

  function api(path, body) {
    internal++;
    var opts = body ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) } : { headers: { Accept: 'application/json' } };
    return fetch(root + path, opts).then(function (r) { return r.json(); }).finally(function () { internal--; });
  }

  function refreshUI(changed) {
    if (!changed) { decorate(); return; }
    if (/\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
    if (window.theme && theme.miniCart) {
      try { theme.miniCart.updateElements(); } catch (e) {}
      try { theme.miniCart.generateCart(); } catch (e) {}
    }
    setTimeout(decorate, 400);
  }

  function reconcile() {
    if (running) { again = true; return; }
    running = true;
    api('cart.js').then(function (cart) {
      var paid = cart.items.filter(function (i) { return !isGift(i); });
      var paidTotal = paid.reduce(function (t, i) { return t + i.final_line_price; }, 0);
      var want = paid.length > 0 && paidTotal >= (cfg.minTotal || 0);
      var jobs = [];
      if (want) {
        var missing = giftIds.filter(function (id) { return !cart.items.some(function (i) { return i.variant_id === id; }); });
        if (missing.length) jobs.push(function () { return api('cart/add.js', { items: missing.map(function (id) { return { id: id, quantity: 1, properties: { _cadeau: 'auto' } }; }) }); });
        cart.items.forEach(function (i) {
          if (isGift(i) && i.quantity !== 1) jobs.push(function () { return api('cart/change.js', { id: i.key, quantity: 1 }); });
        });
      } else {
        var updates = {};
        var any = false;
        cart.items.forEach(function (i) { if (isGift(i)) { updates[i.key] = 0; any = true; } });
        if (any) jobs.push(function () { return api('cart/update.js', { updates: updates }); });
      }
      return jobs.reduce(function (p, job) { return p.then(job); }, Promise.resolve()).then(function () { return jobs.length > 0; });
    }).then(function (changed) {
      refreshUI(changed);
    }).catch(function () {}).finally(function () {
      running = false;
      if (again) { again = false; schedule(); }
    });
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(reconcile, 350);
  }

  var CART_RE = /\/cart\/(add|change|update|clear)(\.js)?/;

  // Requêtes du thème (jQuery et autres scripts en XMLHttpRequest)
  if (window.XMLHttpRequest) {
    var _open = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      if (CART_RE.test(String(url || ''))) {
        this.addEventListener('loadend', function () { if (!internal) schedule(); });
      }
      return _open.apply(this, arguments);
    };
  }
  // Requêtes fetch (applis, autres scripts)
  if (window.fetch) {
    var _fetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = _fetch.apply(this, arguments);
      if (!internal && CART_RE.test(url)) p.then(function () { schedule(); }, function () {});
      return p;
    };
  }

  // Affichage « Offert »
  function giftHandleFrom(node) {
    var links = node.querySelectorAll('a[href]');
    for (var i = 0; i < links.length; i++) {
      var href = links[i].getAttribute('href') || '';
      for (var j = 0; j < gifts.length; j++) if (href.indexOf('/products/' + gifts[j].handle) !== -1) return gifts[j].handle;
    }
    return null;
  }
  function labelHTML() {
    return '<span class="bf-gift-price">' + (cfg.label || 'Offert') + '</span>' + (cfg.note ? '<span class="bf-gift-note">' + cfg.note + '</span>' : '');
  }
  function decorate() {
    // Tiroir panier
    document.querySelectorAll('.mini-cart-item').forEach(function (row) {
      if (row.dataset.bfGift || !giftHandleFrom(row)) return;
      row.dataset.bfGift = '1';
      row.classList.add('bf-gift-line');
      var meta = row.querySelector('.mini-cart-meta');
      if (!meta) return;
      var price = meta.querySelector(':scope > span');
      if (price) {
        var next = price.nextSibling;
        if (next && next.nodeType === 3) next.textContent = '';
        price.outerHTML = labelHTML();
      }
    });
    // Page panier
    document.querySelectorAll('.cart__row').forEach(function (row) {
      if (row.dataset.bfGift || !giftHandleFrom(row)) return;
      row.dataset.bfGift = '1';
      row.classList.add('bf-gift-line');
      row.querySelectorAll('.cart__item-total').forEach(function (p) { p.innerHTML = labelHTML(); });
      row.querySelectorAll('.cart-item__original-price').forEach(function (p) { p.classList.add('bf-gift-hide'); });
    });
  }

  var obsTargets = document.querySelectorAll('.js-mini-cart-content, #CartProducts, .cart');
  if (window.MutationObserver) {
    var mo = new MutationObserver(function () { decorate(); });
    obsTargets.forEach(function (t) { mo.observe(t, { childList: true, subtree: true }); });
  }

  decorate();
  reconcile();
  window.addEventListener('pageshow', function (e) { if (e.persisted) reconcile(); });
})();
